import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'
import BranchesList from './BranchesList'
import BaseSearchSelect from './BaseSearchSelect'
import DriverInfoCard from '../../../components/DriverInfoCard/DriverInfoCard'

const PrivatePointsPanel = ({
  privatePointsFilter,
  setPrivatePointsFilter,
  filteredPrivatePoints,
  privatePointsPagination,
  loadPrivatePointsPage,
  openCreateModal,
  startEdit,
  editingPrivatePoint,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedPrivatePoint,
  setExpandedPrivatePoint,
  expandedOperatorsPrivatePoint,
  setExpandedOperatorsPrivatePoint,
  expandedDriversPrivatePoint,
  setExpandedDriversPrivatePoint,
  expandedBranchesPrivatePoint,
  setExpandedBranchesPrivatePoint,
  loadOperatorsByPrivatePointPage,
  loadDriversByPrivatePointPage,
  loadBranchesByPrivatePointPage,
  operatorsByPrivatePoint,
  driversByPrivatePoint,
  branchesByPrivatePoint,
  operatorsPaginationByPrivatePoint,
  driversPaginationByPrivatePoint,
  branchesPaginationByPrivatePoint,
  operatorsFilterByPrivatePoint,
  driversFilterByPrivatePoint,
  branchesFilterByPrivatePoint,
  setOperatorsFilterByPrivatePoint,
  setDriversFilterByPrivatePoint,
  setBranchesFilterByPrivatePoint,
  employees,
  editingOperatorByPrivatePoint,
  editingDriverByPrivatePoint,
  editingBranchByPrivatePoint,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,loadOperators,
  loadDriversByPrivatePoint,
  expandedDriverByPrivatePoint,
  toggleDriver,
  expandedOperatorByPrivatePoint,
  toggleOperatorPrivatePoint,
  printDriverPass,
  downloadDriverPass,
  privatePoints,
  topBases = [],
  chpps = []
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>Окно: Социальные объекты и Местные самоуправления</div>
        <div>
          <button className={styles.addButton} onClick={() => openCreateModal('privatepoint')}>Добавить частную точку</button>
        </div>
      </div>
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={privatePointsFilter} onChange={(e) => setPrivatePointsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadPrivatePointsPage(1, privatePointsFilter) }} />
        </div>
        {filteredPrivatePoints && filteredPrivatePoints.length ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredPrivatePoints.map((pp, index) => (
                <React.Fragment key={pp.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{index + 1}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedPrivatePoint === pp.id ? null : pp.id); setExpandedPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); }}>{pp.name}</td>
                    <td>{pp.phone || '-'}</td>
                    <td>
                      {pp.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button 
                              onClick={() => window.open(`https://www.google.com/maps?q=${pp.geo}`, '_blank')} 
                              className={styles.geoLinkBtn}
                              title="Открыть в Google Maps"
                            >
                              🗺️ Карты
                            </button>
                            <button 
                              onClick={() => {
                                const elem = document.getElementById(`map-privatepoint-${pp.id}`);
                                if (elem) elem.style.display = elem.style.display === 'none' ? 'block' : 'none';
                              }} 
                              className={styles.mapToggleBtn}
                              title="Показать/скрыть карту"
                            >
                              📌
                            </button>
                          </div>
                          <div id={`map-privatepoint-${pp.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                            <MiniMap geo={pp.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedBranchesPrivatePoint === pp.id ? null : pp.id); setExpandedBranchesPrivatePoint(newVal); if (newVal) loadBranchesByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Филиалы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedOperatorsPrivatePoint === pp.id ? null : pp.id); setExpandedOperatorsPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Операторы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedDriversPrivatePoint === pp.id ? null : pp.id); setExpandedDriversPrivatePoint(newVal); if (newVal) loadDriversByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Водители</button>
                      <button className={styles.smallBtn} style={{ marginLeft: 8 }} onClick={() => startEdit('privatepoint', pp.id, { name: pp.name, phone: pp.phone })}>Изменить</button>
                    </td>
                  </tr>
                  {editingPrivatePoint === pp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>Название</label>
                          <input value={(editPayloads[`privatepoint__${pp.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint__${pp.id}`]: { ...p[`privatepoint__${pp.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`privatepoint__${pp.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint__${pp.id}`]: { ...p[`privatepoint__${pp.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('privatepoint', pp.id)}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint', pp.id)}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {expandedPrivatePoint === pp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {expandedBranchesPrivatePoint === pp.id && (
                            <BranchesList
                              base={pp}
                              baseType="privatepoint"
                              branches={branchesByPrivatePoint[pp.id] || []}
                              branchesFilter={branchesFilterByPrivatePoint[pp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByPrivatePointPage}
                              openCreateModal={openCreateModal}
                              editingBranch={editingBranchByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByPrivatePoint[pp.id] || {}}
                            />
                          )}

                          {expandedOperatorsPrivatePoint === pp.id && (
                            <OperatorsForPrivatePoint
                              pp={pp}
                              operators={operatorsByPrivatePoint[pp.id]}
                              operatorsFilter={operatorsFilterByPrivatePoint[pp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadOperatorsByPrivatePointPage={loadOperatorsByPrivatePointPage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByPrivatePoint={editingOperatorByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByPrivatePoint[pp.id]}
                              expandedOperatorByPrivatePoint={expandedOperatorByPrivatePoint}
                              toggleOperator={toggleOperatorPrivatePoint}
                            />
                          )}

                          {expandedDriversPrivatePoint === pp.id && (
                            <DriversForPrivatePoint
                              pp={pp}
                              drivers={driversByPrivatePoint[pp.id]}
                              driversFilter={driversFilterByPrivatePoint[pp.id]}
                              setDriversFilter={(v) => setDriversFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadDriversByPrivatePointPage={loadDriversByPrivatePointPage}
                              employees={employees}
                              editingDriverByPrivatePoint={editingDriverByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByPrivatePoint[pp.id]}
                              expandedDriverByPrivatePoint={expandedDriverByPrivatePoint}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              privatePoints={privatePoints}
                              topBases={topBases}
                              chpps={chpps}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Список соц.объектов или МСУ пуст</div>
        )}
        {(!privatePointsFilter && privatePointsPagination && privatePointsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!privatePointsPagination.previous} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) - 1)}>Пред.</button>
            <span>Стр. {privatePointsPagination.page || 1} — Всего: {privatePointsPagination.count}</span>
            <button disabled={!privatePointsPagination.next} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) + 1)}>След.</button>
          </div>
        )}
      </div>
    </div>
  )
}

// Inline components for operators and drivers
const OperatorsForPrivatePoint = ({ pp, operators = [], operatorsFilter = '', setOperatorsFilter = () => {}, openCreateModal, loadOperatorsByPrivatePointPage = () => {}, employees = [], editingOperatorByPrivatePoint = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {}, expandedOperatorByPrivatePoint = {}, toggleOperator = () => {} }) => (
  <div style={{ marginTop: 12 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong>Операторы этой соц.объекта или МСУ</strong>
      <div>
        <button className={styles.smallBtn} onClick={() => openCreateModal('privatepoint-operator', { private_point: pp.id, private_point_name: pp.name })}>Добавить оператора</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder="Поиск..." value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByPrivatePointPage(pp.id, 1, operatorsFilter || '') }} />
      </div>
      {(operators && operators.length) ? (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Сотрудник</th>
                <th>Телефон сотрудника</th>
                <th>Дополнительный телефон</th>
                <th>Создано</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {operators.map((op, idx) => {
                const q = (operatorsFilter || '').toLowerCase()
                if (q) {
                  const emp = op.employee_name || String(op.employee)
                  if (!((emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q)))) {
                    return null
                  }
                }
                return (
                  <React.Fragment key={op.id}>
                    <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(pp.id, op.id)}>
                      <td>{idx + 1}</td>
                      <td>{op.employee_name || op.employee}</td>
                      <td>{op.employee_phone || '-'}</td>
                      <td>{op.phone || '-'}</td>
                      <td>{op.created_at}</td>
                      <td>{op.is_active ? 'Активен' : 'Неактивен'}</td>
                      <td>
                        <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('privatepoint-operator', { private_point: pp.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}>Изменить</button>
                      </td>
                    </tr>
                    {expandedOperatorByPrivatePoint[pp.id] === op.id && (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                          <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                            <div style={{ marginTop: 16, borderTop: '1px solid #e0e0e0', paddingTop: 12 }}>
                              <strong>Документы оператора:</strong>
                              {op.documents && op.documents.length > 0 ? (
                                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id} style={{ marginBottom: 8 }}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none' }}>
                                        {doc.file_name}
                                      </a>
                                      <span style={{ marginLeft: 8, color: '#666', fontSize: '12px' }}>
                                        ({(doc.file_size / 1024).toFixed(1)} KB) - {new Date(doc.uploaded_at).toLocaleString('ru-RU')}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div style={{ marginTop: 8, color: '#666', fontStyle: 'italic' }}>Нет документов</div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {editingOperatorByPrivatePoint[pp.id] === op.id && (
                      <tr>
                        <td colSpan={7}>
                          <div style={{ padding: 8 }}>
                            <label>Сотрудник</label>
                            <select value={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                              <option value="">— Выберите сотрудника —</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                            </select>
                            <label style={{ marginLeft: 8 }}>Телефон</label>
                            <input value={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Активен</label>
                            <input type="checkbox" checked={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], is_active: e.target.checked } }))} />
                            
                            <div style={{ marginTop: 8 }}>
                              <label>Документы</label>
                              <input 
                                type="file" 
                                multiple 
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  const files = Array.from(e.target.files || [])
                                  setEditPayloads(p => ({ 
                                    ...p, 
                                    [`privatepoint-operator_${pp.id}_${op.id}`]: { 
                                      ...p[`privatepoint-operator_${pp.id}_${op.id}`], 
                                      newDocuments: files 
                                    } 
                                  }))
                                }}
                              />
                              {op.documents && op.documents.length > 0 && (
                                <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                  <strong>Текущие документы:</strong>
                                  <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                    {op.documents.map(doc => (
                                      <li key={doc.id}>
                                        <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                          {doc.file_name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            
                            <div style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('privatepoint-operator', { private_point: pp.id, opId: op.id })}>Сохранить</button>
                              <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint-operator', { private_point: pp.id })}>Отмена</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
          {(!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByPrivatePointPage(pp.id, (operatorsPagination.page || 1) - 1)}>Пред.</button>
              <span>Стр. {operatorsPagination.page || 1} — Всего: {operatorsPagination.count}</span>
              <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByPrivatePointPage(pp.id, (operatorsPagination.page || 1) + 1)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div>Операторы не найдены</div>
      )}
    </div>
  </div>
)

const DriversForPrivatePoint = ({ pp, drivers = [], driversFilter = '', setDriversFilter = () => {}, openCreateModal, loadDriversByPrivatePointPage = () => {}, employees = [], editingDriverByPrivatePoint = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByPrivatePoint = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, privatePoints = [], topBases = [], chpps = [] }) => (
  <div style={{ marginTop: 12 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong>Водители этой соц.объекта или МСУ</strong>
      <div>
        <button className={styles.smallBtn} onClick={() => openCreateModal('privatepoint-driver', { private_point: pp.id, private_point_name: pp.name })}>Добавить водителя</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder="Поиск..." value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByPrivatePointPage(pp.id, 1, driversFilter || '') }} />
      </div>
      {(drivers && drivers.length) ? (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Сотрудник</th>
                <th>Телефон</th>
                <th>Дополнительный ном.тел.</th>
                <th>Номер машины</th>
                <th>Модель машины</th>
                <th>Срок пропуска (дней)</th>
                <th>Дата истечения</th>
                <th>Лимит погрузок</th>
                <th>Текущие погрузки</th>
                <th>UID</th>
                <th>QR string</th>
                <th>Фото</th>
                <th>QR (изображение)</th>
                <th>Создано</th>
                <th>Статус</th>
                <th>Статус машины</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((d, index) => (
                <React.Fragment key={d.id}>
                  <tr onClick={(e) => { if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.tagName === 'IMG' || e.target.closest && e.target.closest('button')) ) return; toggleDriver(pp.id, d.id) }} style={{ cursor: 'pointer' }}>
                    <td>{index + 1}</td>
                    <td>{d.employee_name || d.employee}</td>
                    <td>{d.employee_phone || '-'}</td>
                    <td>{d.phone || '-'}</td>
                    <td>{d.vehicle_number || '-'}</td>
                    <td>{d.vehicle_model || '-'}</td>
                    <td>{d.pass_expiry_days || '-'}</td>
                    <td>{d.pass_expiry_date ? new Date(d.pass_expiry_date).toLocaleDateString() : '-'}</td>
                    <td>{d.pass_loads_limit || '-'}</td>
                    <td>{d.pass_loads_count || 0}</td>
                    <td>
                      {d.uid ? (
                        <button className={styles.uidBtn} onClick={(ev) => {
                          ev.stopPropagation();
                          try {
                            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                              navigator.clipboard.writeText(d.uid)
                            } else {
                              const ta = document.createElement('textarea')
                              ta.value = d.uid
                              document.body.appendChild(ta)
                              ta.select()
                              document.execCommand('copy')
                              ta.remove()
                            }
                          } catch (e) {
                            // ignore
                          }
                        }}>{d.uid}</button>
                      ) : '-' }
                    </td>
                    <td>{d.qrcode_scr || '-'}</td>
                    <td>
                      {d.photo ? (
                        <img className={styles.thumb} src={(d.photo && d.photo.url) ? d.photo.url : d.photo} alt={`photo-${d.id}`} />
                      ) : '-'}
                    </td>
                    <td>
                      {d.qrcode_img ? (
                        <img className={styles.thumb} style={{ cursor: 'pointer' }} onClick={(ev) => { ev.stopPropagation(); downloadDriverPass(d, 'Социальные объекты / МСУ', privatePoints.find(x => String(x.id) === String(d.private_point))?.name || '') }} src={(d.qrcode_img && d.qrcode_img.url) ? d.qrcode_img.url : d.qrcode_img} alt={`qrcode-${d.id}`} />
                      ) : '-'}
                    </td>
                    <td>{d.created_at}</td>
                    <td>{d.is_active ? 'Активен' : 'Неактивен'}</td>
                    <td>{d.status_display}</td>
                    <td>
                      <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('privatepoint-driver', { private_point: pp.id, drId: d.id }, { employee: d.employee, private_point: d.private_point || pp.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active, pass_expiry_days: d.pass_expiry_days, pass_loads_limit: d.pass_loads_limit }) }}>Изменить</button>
                    </td>
                  </tr>
                  {expandedDriverByPrivatePoint[pp.id] === d.id && (
                    <tr>
                      <td colSpan={18} style={{ textAlign: 'start', padding: 12 }}>
                        <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                            <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); printDriverPass(d, 'Социальные объекты / МСУ', privatePoints.find(x => String(x.id) === String(d.private_point))?.name || '') }}>Печать</button>
                          </div>
                          <DriverInfoCard driver={d} />
                        </div>
                      </td>
                    </tr>
                  )}
                  {editingDriverByPrivatePoint[pp.id] === d.id && (
                    <tr>
                      <td colSpan={18}>
                        <div style={{ padding: 8 }}>
                          <label>Сотрудник</label>
                          <div style={{ display: 'inline-block', minWidth: 220 }}>
                            <select value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).employee || ''} onChange={(e) => { setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], employee: Number(e.target.value) } })); }}>
                              <option value="">— Выберите сотрудника —</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                            </select>
                          </div>
                          <label style={{ marginLeft: 8 }}>Тип базы</label>
                          <select 
                            value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')} 
                            onChange={(e) => { 
                              const baseType = e.target.value;
                              setEditPayloads(p => ({ 
                                ...p, 
                                [`privatepoint-driver_${pp.id}_${d.id}`]: { 
                                  ...p[`privatepoint-driver_${pp.id}_${d.id}`], 
                                  base_type: baseType,
                                  top_base: baseType === 'top_base' ? (p[`privatepoint-driver_${pp.id}_${d.id}`]?.top_base || null) : null,
                                  chpp: baseType === 'chpp' ? (p[`privatepoint-driver_${pp.id}_${d.id}`]?.chpp || null) : null,
                                  private_point: baseType === 'private_point' ? (p[`privatepoint-driver_${pp.id}_${d.id}`]?.private_point || null) : null
                                } 
                              })); 
                            }}
                            style={{ marginLeft: 8 }}
                          >
                            <option value="top_base">ТОП-База</option>
                            <option value="chpp">ТЭЦ</option>
                            <option value="private_point">Соц.объект/МСУ</option>
                          </select>
                          <label style={{ marginLeft: 8 }}>
                            {(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type === 'chpp' ? 'ТЭЦ' : 
                             (editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type === 'private_point' ? 'Соц.объект/МСУ' : 'ТОП-База'}
                          </label>
                          <BaseSearchSelect
                            baseType={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')}
                            value={
                              (editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type === 'chpp' ? 
                                ((editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).chpp || d.chpp || '') : 
                              (editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type === 'private_point' ? 
                                ((editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).private_point || d.private_point || pp.id) : 
                                ((editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).top_base || d.top_base || '')
                            }
                            onChange={(baseId) => {
                              const baseType = (editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point');
                              setEditPayloads(p => ({ 
                                ...p, 
                                [`privatepoint-driver_${pp.id}_${d.id}`]: { 
                                  ...p[`privatepoint-driver_${pp.id}_${d.id}`], 
                                  [baseType]: baseId
                                } 
                              }));
                            }}
                            placeholder="Поиск базы..."
                            style={{ marginLeft: 8 }}
                          />
                          <label style={{ marginLeft: 8 }}>Номер машины</label>
                          <input value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Модель</label>
                          <input value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Срок (дней)</label>
                          <input type="number" value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).pass_expiry_days || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], pass_expiry_days: Number(e.target.value) } }))} />
                          <label style={{ marginLeft: 8 }}>Лимит погрузок</label>
                          <input type="number" value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).pass_loads_limit || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], pass_loads_limit: Number(e.target.value) } }))} />
                          <label style={{ marginLeft: 8 }}>Активен</label>
                          <input type="checkbox" checked={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], is_active: e.target.checked } }))} />
                          
                          <div style={{ marginTop: 8 }}>
                            <label>Документы</label>
                            <input 
                              type="file" 
                              multiple 
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({ 
                                  ...p, 
                                  [`privatepoint-driver_${pp.id}_${d.id}`]: { 
                                    ...p[`privatepoint-driver_${pp.id}_${d.id}`], 
                                    newDocuments: files 
                                  } 
                                }))
                              }}
                            />
                            {d.documents && d.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>Текущие документы:</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {d.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {doc.file_name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          
                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('privatepoint-driver', { private_point: pp.id, drId: d.id })}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint-driver', { private_point: pp.id })}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {(driversPagination && driversPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!driversPagination.previous} onClick={() => loadDriversByPrivatePointPage(pp.id, (driversPagination.page || 1) - 1, driversFilter)}>Пред.</button>
              <span>Стр. {driversPagination.page || 1} из {Math.ceil(driversPagination.count / 25)} — Всего: {driversPagination.count}</span>
              <button disabled={!driversPagination.next} onClick={() => loadDriversByPrivatePointPage(pp.id, (driversPagination.page || 1) + 1, driversFilter)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div>Нет водителей для этой соц.объекта или МСУ</div>
      )}
    </div>
  </div>
)

export default PrivatePointsPanel
